export const SkeletonCell = () => {
  return <div className="w-full animate-pulse rounded-lg bg-alpha-100 p-3" />;
};
